import { Cpu, ArrowRightLeft, Headset, Phone, Code, DatabaseBackup, ShieldCheck, GraduationCap, Server } from "lucide-react";

const MAP = {
  Cpu, ArrowRightLeft, Headset, Phone, Code, DatabaseBackup, ShieldCheck, GraduationCap, Server,
};

export function ServiceIcon({ name, className }) {
  const Icon = MAP[name] || Cpu;
  return <Icon className={className} strokeWidth={1.5} />;
}
